/**
 * Size/leading that follow the surrounding line rather than declaring a rung.
 *
 * The `length:` hint is what makes tailwind-merge treat this as a font-size so
 * it replaces a wrapper's `text-sm`; `text-[inherit]` would be read as a colour.
 */
export const INHERIT_TYPE_SIZE_CLASS = 'text-[length:inherit] leading-[inherit]';
